import React, { useEffect } from "react";
import {
  Container,
  Box,
  TextField,
  Typography,
  Paper,
  InputAdornment,
  Grid,
  Button,
} from "@mui/material";
import {
  AccountCircle,
  ContactMail,
  Email,
  Message,
  Send,
} from "@mui/icons-material";
import { useParams } from "react-router-dom";
import {
  contactDeveloper,
  getDeveloper,
} from "../../features/Developers/developerSlice";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";

const Contact = () => {
  const { developer, developers } = useSelector((state) => state.developers);
  const { attributes, projects } = developer;
  const [contactLogs, setContactLogs] = useState({
    name: "",
    email: "",
    message: "",
    user_id: attributes?.id,
    devEmail: attributes?.email,
  });
  const { dev } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getDeveloper(`${dev}`));
  }, []);

  const handleContactChange = (e) => {
    setContactLogs({
      ...contactLogs,
      [e.target.name]: e.target.value,
    });
  };

  const handleContactSubmit = (e) => {
    e.preventDefault();
    dispatch(contactDeveloper(contactLogs));
  };

  return (
    <>
      {/* {JSON.stringify(contactLogs)} */}
      <Container
        maxWidth="xl"
        sx={{
          height: "100vh",
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
        }}
      >
        <Box sx={{ mb: { xs: 5, md: 1 } }}>
          <Paper p={2} elevation={2}>
            <Box sx={{ p: 2 }} component="form" onSubmit={handleContactSubmit}>
              <Box>
                <Typography variant="h3">Contact me</Typography>
                <Typography variant="body1">
                  # Submit the form below or shoot me an email -
                  admin@stemlab.com.ng
                </Typography>
              </Box>

              <Box py={2}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                      <ContactMail
                        sx={{ color: "action.active", mr: 1, my: 0.5 }}
                      />
                      <TextField
                        id="input-with-sx"
                        label="Name"
                        variant="standard"
                        fullWidth
                        name="name"
                        value={contactLogs.name}
                        onChange={handleContactChange}
                        required
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                      <Email sx={{ color: "action.active", mr: 1, my: 0.5 }} />
                      <TextField
                        id="input-with-sx"
                        label="Email "
                        variant="standard"
                        fullWidth
                        value={contactLogs.email}
                        onChange={handleContactChange}
                        name="email"
                        required
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                      <Message
                        sx={{ color: "action.active", mr: 1, my: 0.5 }}
                      />
                      <TextField
                        id="filled-textarea"
                        label="send your message"
                        placeholder="send email"
                        multiline
                        variant="filled"
                        fullWidth
                        name="message"
                        value={contactLogs.message}
                        onChange={handleContactChange}
                        required
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Box>
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Button variant="outlined" size="large" type="submit">
                  <Send pl={2} />
                </Button>
              </Box>
            </Box>
          </Paper>
        </Box>
      </Container>
    </>
  );
};

export default Contact;
